export default class MaxAttemptsReach extends Error {
  name = 'MaxAttemptsReach';

  constructor(readonly message = 'Max Attempts Reach') {
    super(message);
  }
}
